export default __webpack_public_path__ + "static/media/lilla3.3c61084c.png";